import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-arrow-down\"><defs><style>#icon-arrow-down .cls-1{opacity:0.8;}</style></defs><title>资源 116</title><g id=\"icon-arrow-down_图层_2\" data-name=\"图层 2\"><g id=\"icon-arrow-down_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M0,10A10,10,0,1,0,10,0,10,10,0,0,0,0,10ZM6.63,8.28a.91.91,0,0,1,1.29,0L10,10.36l2.08-2.08a.91.91,0,0,1,1.29,0,.89.89,0,0,1,0,1.28l-2.73,2.73a.89.89,0,0,1-1.28,0L6.63,9.56A.89.89,0,0,1,6.63,8.28Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-down.svg
// module id = Peom
// module chunks = 71